module.exports = __webpack_public_path__ + "img/9788950961893.7a92cbd1.jpg";